import React, { useState } from 'react'
import Popup from '../../../../../components/popup/Popup'
import Button from '../../../../../components/button/Button'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import styles from "./SendPayerCopyByEmailModal.styles"
import commonStyles from "../../ManageForms.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'

const SendPayerCopyByEmailModal = ({
    isPopupOpen,
    onCloseCb = () => { },
    onSubmitCb = () => { },
    title = "Send Payer Copy by Email",
    options = [{ label: "1099-Misc", value: "1099-MISC" }, { label: "W-2", value: "W-2" },
    { label: "1099-NEC", value: "1099-NEC" }]
}) => {

    const defaultOption = { label: "Select form", value: "select" }
    const [selectedForm, setSelectedForm] = useState(defaultOption);

    const handleSubmit = () => {
        if(selectedForm.value !== defaultOption.value) {
            onSubmitCb(selectedForm)
        }
    }
    return (
        <>
            <Popup
                title={title}
                isPopupOpen={isPopupOpen}
                onCloseCb={onCloseCb}
                childrenStyles={styles.childrenStyles}
            >
                <div>
                    <SelectDropdown
                        name="form"
                        value={selectedForm}
                        onSelectCb={(name, selectedOption) => setSelectedForm(selectedOption)}
                        options={options}
                        dropdownMenuStyle={styles.dropdownMenu}
                    />
                </div>

                <div style={styles.buttonsContainer}>
                    <Button style={commonStyles.button} onClickCb={ handleSubmit }>Submit</Button>
                    <Button
                        style={commonStyles.button}
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={onCloseCb}
                    >
                        Cancel
                    </Button>
                </div>
            </Popup>
        </>
    )
}

export default SendPayerCopyByEmailModal